import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyboardListenerService } from './services/keyboard-listener.service';
import { KeyboardSearchDirective } from './directives/keyboard-search/keyboard-search.directive';
import { KeyboardSearchElementDirective } from './directives/keyboard-search-element/keyboard-search-element.directive';

@NgModule({
	declarations: [KeyboardSearchDirective, KeyboardSearchElementDirective],
	exports: [KeyboardSearchDirective, KeyboardSearchElementDirective],
	imports: [CommonModule],
	providers: [KeyboardListenerService],
})
export class KeyboardSearchModule {}
